import { Helmet } from "react-helmet-async";

const SITE_NAME = "Wertbild Immobilienfotografie";
const SITE_URL = "https://wertbild.de";
const DEFAULT_IMAGE = `${SITE_URL}/wertbild-logo.png`;

export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, type = "website", noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Immobilienfotograf in NRW – Aachen · Köln · Düren`;
  const url = `${SITE_URL}${path}`;
  const desc = description || "Professionelle Immobilien- und Architekturfotografie, Drohnenaufnahmen, 3D-Touren, Virtual Staging und Immobilienvideos für Makler, Eigentümer und Bauträger in NRW – Wertbild aus Düren.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="de_DE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
